import { isLocalUrl } from '../helpers';

export default function cardWidget() {
  const widgetName = 'cardWidget';
  const widgetOpts = cardWidgetOpts;

  // you can remove this and import the validateWindowSize auxiliary function under Helpers/helpers.js
  const breakpoint = 800;
  const isDesktopScreen = $(globalThis).width() >= breakpoint;
  const wrapContainerClass = 'cardWidget-container-wrapper';
  const $widget = $(`#${widgetName}`);

  $widget.wrap(`<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: isDesktopScreen ? [] : ['all'],
    showDescription: true,
    moreButton: true,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    textOverImage: true,
    maxItemsVisible: 10,
    itemsPerPanel: 1,
    buyNowButton: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomCards(data.items);
      } else {
        $(`.${wrapContainerClass}`).remove();
      }
    },
  });

  function createCustomCards(widgetData) {
    $widget.find('.image-container').append('<div class="overlay"></div>');
    $widget.find('.card-content').remove();

    $widget.find('.card-widget-item').each(function (x) {
      const { Title, Description, URL } = widgetData[x];
      let urlAttribute = isLocalUrl(URL) ? '' : 'target="_blank"';

      const $cardItem = $(this);

      $cardItem.append(`
          <div class="card-content">
            <div class="widget-title-wrapper">
              <span class="widget-title">
                ${Title}</span>
              </div>
            <div class="hover-content">
              ${Description ? `<p class="widget-description">${Description}</p>` : ''}
              ${
                URL
                  ? `<a href="${URL}" class="button" ${urlAttribute}>
                <div class="button-icon"></div>
              </a>`
                  : ''
              }
            </div>
          </div>`);

      if (isLocalUrl(URL)) {
        $cardItem.removeAttr('target');
      }

      if (!URL && !Description) {
        $cardItem.addClass('empty-card').removeAttr('href');
      } else if (!URL && Description) {
        $cardItem.addClass('just-desc').removeAttr('href').attr('tabindex', 0);
      } else if (URL && !Description) {
        $cardItem.addClass('only-url');
      }
    });
  }
}
